import { BlockId } from '../../defs/block';
import {
  BlockEntity,
  TunaFishBlockEntity,
  spawnBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { blockViewAssets } from '../../util/blockTools';
import { IEffect } from './IEffect';

export type TunaCanEffectOptions = {
  subject: BlockEntity;
};

const spawnId: BlockId = 'tunaFish';

export class TunaCanEffect implements IEffect {
  private readonly scene: GameScene;
  private readonly options: TunaCanEffectOptions;

  constructor(scene: GameScene, options: TunaCanEffectOptions) {
    this.scene = scene;
    this.options = options;
  }

  public static assets() {
    return blockViewAssets(spawnId);
  }

  public async execute() {
    const entity = spawnBlockEntity(
      this.scene,
      { id: spawnId },
      this.options.subject.c.position.mapPosition,
    ) as TunaFishBlockEntity;
    entity.c.blockTunaFish.view.playTransition();
  }
}
